<template>
    <div class="app-main">
        <keep-alive>
            <router-view></router-view>
        </keep-alive>
    </div>
</template>

<script>
export default {
    name: "AppMain"
}
</script>

<style scoped>
.app-main {
    min-height: calc(100vh - 180px);
    padding: 10px;
    overflow-y: scroll;
}
</style>
